export default {
    renderFileAsDataURL(file) {
		return new Promise((resolve, reject) => {
			if (typeof FileReader === 'function') {
				const reader = new FileReader();
				reader.onload = (event) => {
					resolve(event.target.result);
				};
				reader.readAsDataURL(file);
			} else {
				reject('FileReader is not function');
			}
		})
	},
	downloadFileByBlob(blob, fileName) {
		const href = URL.createObjectURL(blob);
		this.linkTo(href, { download: fileName })
	},
	linkTo(url, option = {}) {
		const a = document.createElement('a');
		a.href = url;
		for (let key in option) {
			a[key] = option[key];
		}
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	}
}